<template>
  <div>
    <v-select 
        :value="selected_connection"
        v-bind:items="connections"
        item-value="code" 
        item-text="description" 
        :label="label"
        :dense="isDense"
        :clearable="false"
        @change="updateData">
    </v-select>
  </div>
</template>

<script>
  export default {
    watch:{
        selected_connection: {            
            handler(){
                // this is needed when the selected language is set from outside this component
                // the change-event will not fire so we watch the value and emit the change if needed
                this.updateData(this.selected_connection);
            } 
        },
    },       
    props: {
      selected_connection: {
          type: String,
          default: ''
      },            
      label: {
        type: String,
        default: ''
      },  
      field: {
          type: String,
          default: 'hgrp_conn_code',
      },
      isDense:{
          type: Boolean,
          default: true
      }
    },  
    data() {
      return {
        connections:[]
      }
    },      
    created () {
      this.connections = 
      [
        {code: 'Qenner', description: 'Qenner'},
      ];
    },
    mounted () {
      this.updateData(this.selected_connection);
    },
    methods: {
      updateData(v){
          this.$emit('updateData', { "field": this.field, "value": v === null ? 'Qenner' : v })
      }           
    }   
  }
</script>

<style scoped>

</style>